import { Injectable } from '@angular/core';
import { User } from '@challenger/care/models/user.model';
import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';

import { AuthenticatingUser, SetUserDetail } from '../actions/user.actions';

export class UserStateModel extends User {
  isAuthenticating: boolean;
  error: string;
}

const USER_STATE_TOKEN = new StateToken<UserStateModel>('user');

@State<UserStateModel>({
  name: USER_STATE_TOKEN,
  defaults: null,
})
@Injectable()
export class UserState {
  constructor() {}

  @Selector()
  static getUserClaims(state: UserStateModel) {
    return state.claims;
  }

  @Selector()
  static getUserDisplayName(state: UserStateModel) {
    return state.claims.displayName;
  }

  @Selector()
  static getUserAccountId(state: UserStateModel) {
    return state.claims.vmAccountId;
  }

  @Selector()
  static getVMHouseholdId(state: UserStateModel) {
    return state.claims.vmHouseholdId;
  }

  @Selector()
  static getError(state: UserStateModel) {
    return state.error;
  }
  @Selector()
  static getIsAuthenticating(state: UserStateModel) {
    return state.isAuthenticating;
  }
  @Selector()
  static getIdToken(state: UserStateModel) {
    return state.idToken.value;
  }

  @Action(SetUserDetail)
  setUserDetail(ctx: StateContext<any | null>, action: SetUserDetail): void {
    ctx.setState({ ...action.payload });
  }

  @Action(AuthenticatingUser)
  authenticatingUser({ patchState, getState }: StateContext<UserStateModel>, action: any) {
    patchState({ ...getState(), isAuthenticating: action.isAuthenticating });
  }
}
